import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import classes from "./LanguageDropdown.module.css";

import { languageMenu } from "../../../configs/i18nConfig";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";

const LanguageDropdown = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [language, setLanguage] = useState(languageMenu[1]);

  if (openModal) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  useEffect(() => {
    const detectedLanguageMenu = languageMenu.find((l) =>
      i18n.language.includes(l.code)
    );

    if (detectedLanguageMenu) setLanguage(detectedLanguageMenu);
  }, [i18n.language]);

  const handleOnLanguageMenuItemSelected = (item) => {
    if (language.id !== item.id) {
      setLanguage(item);
      i18n.changeLanguage(item.code);
    }
  };

  const onClickLanguage = (language) => {
    handleOnLanguageMenuItemSelected(language);
    setOpenModal(false);
  };

  const options = languageMenu.filter((item) => language.id !== item?.id);

  return (
    <div className={classes["wrapper"]}>
      <div
        onClick={() => setOpenModal(true)}
        className={classes["selected-lang"]}
      >
        {language.title} <img src={language.flag} alt="" />
        <ExpandMoreIcon />
      </div>
      {openModal ? (
        <div className={classes["modal-wrapper"]}>
          <div className={classes["language-modal"]}>
            <h3 className={classes["modal-title"]}>{t("Choose language:")}</h3>
            <CloseIcon
              onClick={() => setOpenModal(false)}
              className={classes["close-icon"]}
            />
            {options.map((language) => {
              return (
                <div
                  className={classes["language"]}
                  onClick={() => onClickLanguage(language)}
                  key={language.id}
                >
                  <img
                    className={classes["language-flag"]}
                    src={language.flag}
                    alt="flag"
                  />
                  <p className={classes["language-title"]}>{language.title}</p>
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default LanguageDropdown;
